import React from 'react';
import { Link } from 'react-router-dom';

const RouteNotFound = () => (
  <div className="route-not-found">
    <p>The requested page was not found click <Link to="/">here</Link> to go back</p>
  </div>
);

export default RouteNotFound;



// WEBPACK FOOTER //
// ./src/components/RouteNotFound/index.js